export const isEmptyObject = (obj: any) => Object.keys(obj).length === 0 && obj.constructor === Object;
